<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="800" scrollable :persistent="sending">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Tạo tài khoản App và gửi tin nhắn
        <v-spacer></v-spacer>
        <v-btn dark icon :disabled="sending" @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <!-- selected student table -->
        <div class="mx-0" v-if="step === 'preview'">
          <div class="d-flex flex-column">
            <div class="mb-4">
              <span><b>Nhóm nhận tin</b></span
              >: {{ students.length }} Học viên
            </div>
            <div class="mb-2">
              Hệ thống sẽ gửi tin nhắn thông báo thông tin tài khoản (để đăng nhập và sử dụng APP) tới các số điện thoại
              đã đăng kí. Vui lòng kiểm tra lại thông tin và bấm
              <span><b>[Gửi]</b></span> để tiếp tục.
            </div>
            <div>
              <span class="error--text">*</span>&nbsp;<b>Lưu ý</b>:<br />
              1. Tài khoản sổ liên lạc phải đang <span><b>Hoạt động</b></span> và có <span><b>SĐT đăng ký</b></span
              ><br />
              2. <span><b>Hình thức sử dụng</b></span> chưa có APP<br />
              3. Nếu gửi đồng thời quá nhiều Học viên, quá trình gửi sẽ tốn thời gian.<br />
              4. Khi bắt đầu gửi, vui lòng không đóng cửa sổ cho tới khi hệ thống báo kết quả.
            </div>
          </div>

          <v-card class="mt-4 pa-4" outlined v-if="sending">
            <div class="d-flex justify-space-between align-center mb-2">
              <div>
                <b>Đang tạo tài khoản App</b>
                <div class="caption grey--text text--darken-1">
                  Đang xử lý nhóm {{ currentChunkNo }} / {{ totalChunkNo }}. Vui lòng không đóng cửa sổ.
                </div>
              </div>
              <div class="text-right">
                <b>{{ processedStudentNo }}</b> / {{ validStudentNo }} học viên
              </div>
            </div>
            <v-progress-linear :value="progressPercent" color="primary" height="22" rounded>
              <strong class="white--text">{{ progressPercent }}%</strong>
            </v-progress-linear>
            <div class="d-flex justify-space-between mt-2 caption">
              <span>Thành công tạm tính: {{ processedSuccessNo }}</span>
              <span>Thất bại: {{ errorCreatedUsers.length }}</span>
            </div>
          </v-card>

          <v-card class="mt-4" outlined>
            <v-data-table
              :headers="headers"
              :items="students"
              :footer-props="{
                'items-per-page-text': 'Học viên mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': students.length > 100 ? [5, 15, 30] : [5, 15, -1]
              }"
            >
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px;">
                      {{ item | getContactBookPhones }}
                    </div>
                  </template>
                  <span>{{ item | getContactBookPhones }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.senderMethod`]="{ item }">
                <span>{{ item | getNotificationMethod }}</span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip :color="item | getContactBookStatusColor" small class="white--text">{{
                  item | getContactBookStatus
                }}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </div>

        <!-- error student table -->
        <div class="mx-0" v-else>
          <div class="d-flex flex-column">
            <div>
              Tổng số học viên đã chọn: <b>{{ totalSelectedStudents }}</b>
            </div>
            <div>
              Học viên không hợp lệ: <b>{{ totalSelectedStudents - validStudentNo }}</b>
            </div>
            <div>
              Học viên hợp lệ: <b>{{ validStudentNo }}</b>
            </div>
            <div>
              Tạo tài khoản thành công: <span class="green--text">{{ validStudentNo - errorCreatedUsers.length }}</span>
            </div>
            <div>
              Tạo tài khoản thất bại: <span class="red--text">{{ errorCreatedUsers.length }}</span>
            </div>

            <div class="my-2">
              <h4>Vui lòng xem lịch sử gửi tin nhắn tại trang <b>[Lịch sử gửi tin]</b></h4>
            </div>
          </div>

          <v-card class="mt-4" outlined v-if="errorCreatedUsers.length">
            <v-data-table
              :headers="headers"
              :items="errorCreatedUsers"
              :footer-props="{
                'items-per-page-text': 'Học viên mỗi trang',
                'items-per-page-all-text': 'Tất cả',
                'items-per-page-options': students.length > 100 ? [5, 15, 30] : [5, 15, -1]
              }"
            >
              <template v-slot:top>
                <div class="px-4">
                  Học viên tạo lỗi
                </div>
              </template>
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                {{ items.itemsLength }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <CardStudentName :student="item" link />
              </template>
              <template v-slot:[`item.phone`]="{ item }">
                <v-tooltip max-width="250px" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px;">
                      {{ item | getContactBookPhones }}
                    </div>
                  </template>
                  <span>{{ item | getContactBookPhones }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.classes`]="{ item }">
                <router-link
                  style="text-decoration: none"
                  :to="'/class/' + (item.currentClass && item.currentClass.id)"
                >
                  <span v-if="item.currentClass">{{ item.currentClass && item.currentClass.title }}</span>
                </router-link>
              </template>
              <template v-slot:[`item.dob`]="{ item }">
                <span>{{ item.dob | ddmmyyyy }}</span>
              </template>
              <template v-slot:[`item.senderMethod`]="{ item }">
                <span>{{ item | getNotificationMethod }}</span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-chip :color="item | getContactBookStatusColor" small class="white--text">{{
                  item | getContactBookStatus
                }}</v-chip>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn v-if="step === 'preview'" class="ma-2 px-4" outlined light depressed :disabled="sending" @click="cancel"
          >Hủy</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          v-if="step === 'preview'"
          class="ma-2"
          dark
          depressed
          color="primary"
          :loading="sending"
          :disabled="sending"
          @click="send"
          >Gửi
        </v-btn>
        <v-btn v-if="step === 'noti'" class="ma-2" dark depressed @click="cancel" color="primary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  components: { CardStudentName },
  props: {
    state: Boolean,
    students: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Học viên',
          value: 'name',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
          align: 'left',
          sortable: false,
          show: true
        },
        { text: 'Lớp', value: 'classes', align: 'left', sortable: false, show: true },
        {
          text: 'Hình thức sử dụng',
          value: 'senderMethod',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'SĐT đăng ký',
          value: 'phone',
          align: 'left',
          sortable: false,
          show: true
        },
        {
          text: 'Trạng thái',
          value: 'status',
          align: 'left',
          sortable: false,
          show: true
        }
      ],
      dialog: false,
      step: 'preview',
      errorCreatedUsers: [],
      successCreatedUsers: [],
      validStudentNo: 0,
      totalSelectedStudents: 0,
      sending: false,
      processedStudentNo: 0,
      processedChunkNo: 0,
      currentChunkNo: 0,
      totalChunkNo: 0,
      bulkActivateAppChunkSize: 20
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('role', ['roleIdByName']),
    progressPercent() {
      if (!this.validStudentNo) return 0
      return Math.min(100, Math.round((this.processedStudentNo / this.validStudentNo) * 100))
    },
    processedSuccessNo() {
      return Math.max(0, this.processedStudentNo - this.errorCreatedUsers.length)
    }
  },
  methods: {
    ...mapActions('ContactBook', ['bulkActivateApp']),
    chunkStudents(students) {
      const chunks = []
      for (let i = 0; i < students.length; i += this.bulkActivateAppChunkSize) {
        chunks.push(students.slice(i, i + this.bulkActivateAppChunkSize))
      }
      return chunks
    },
    getFailedStudents(result, students) {
      const failedStudentIds = new Set(((result && result.failed) || []).map(item => String(item.studentId)))
      return students.filter(student => failedStudentIds.has(String(student.id)))
    },
    async send() {
      if (this.sending) return

      this.errorCreatedUsers = []
      this.processedStudentNo = 0
      this.processedChunkNo = 0
      this.currentChunkNo = 0
      this.totalChunkNo = 0
      this.totalSelectedStudents = this.students.length
      let shouldRefresh = false
      const filteredStudents = this.students.filter(s => {
        const checks = {
          hasContactBook: !!s.contactBook,
          notApp: s.contactBook ? !s.contactBook.isApp : false,
          statusActive: s.contactBook ? s.contactBook.status === 'active' : false,
          hasPhones: s.contactBook ? !!s.contactBook.phones : false,
          noUser: !s.user || !s.user.id
        }
        const failed = Object.entries(checks).filter(([, v]) => !v).map(([k]) => k)
        if (failed.length) {
          console.warn(`[ActiveApp] Student "${s.name}" filtered out — failed: ${failed.join(', ')}`, checks)
        }
        return Object.values(checks).every(Boolean)
      })
      this.validStudentNo = filteredStudents.length
      const chunks = this.chunkStudents(filteredStudents)
      this.totalChunkNo = chunks.length
      this.sending = true

      try {
        for (let i = 0; i < chunks.length; i += 1) {
          const chunk = chunks[i]
          this.currentChunkNo = i + 1

          try {
            const result = await this.bulkActivateApp({
              students: chunk,
              role: this.roleIdByName('Student'),
              staffId: this.profile.id,
              passwordGenerator: () => this.$utils.autoGeneratePassword()
            })
            shouldRefresh = true
            this.errorCreatedUsers = [...this.errorCreatedUsers, ...this.getFailedStudents(result, chunk)]
          } catch (error) {
            this.errorCreatedUsers = [...this.errorCreatedUsers, ...chunk]
          }

          this.processedChunkNo += 1
          this.processedStudentNo += chunk.length
        }
      } finally {
        this.sending = false
      }

      this.step = 'noti'
      this.$emit('done', { shouldRefresh })
    },
    cancel() {
      if (this.sending) return

      this.reset()
      this.dialog = false
    },
    reset() {
      this.step = 'preview'
      this.errorCreatedUsers = []
      this.successCreatedUsers = []
      this.validStudentNo = 0
      this.totalSelectedStudents = 0
      this.sending = false
      this.processedStudentNo = 0
      this.processedChunkNo = 0
      this.currentChunkNo = 0
      this.totalChunkNo = 0
    }
  },

  watch: {
    state() {
      this.step = 'preview'
      this.dialog = true
    }
  }
}
</script>

<style scoped></style>
